import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["spinner"];

  show(e) {
    if (e.target.hasAttribute("data-loading-ignore")) {
      return;
    }
    this.spinnerTargets.forEach(spinner => {
      spinner.classList.remove("hidden");
      spinner.classList.add("opacity-100");
    });
  }

  hide() {
    this.spinnerTargets.forEach(spinner => {
      spinner.classList.add("hidden");
      spinner.classList.remove("opacity-100");
    });
  }
}
